module.exports = __webpack_public_path__ + "static/fifth_user_image4-5a19f5e5e2388167133fea7fc35669ec.jpg";